export function inferCountry(name) {
    const n = name.toLowerCase();
    if (n.includes('ssa') || n.includes('sanj'))
        return 'South Africa';
    return 'UK';
}
